"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ImportStatusTrans = exports.ImportStatus = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _nhanh = require("@/api/nhanh");
var _product = require("@/api/product");
var _vuePropertyDecorator = require("vue-property-decorator");
var _DetailImportModal = _interopRequireDefault(require("./components/DetailImportModal.vue"));
var _ImportModal = _interopRequireDefault(require("./components/ImportModal.vue"));
var _ImportTable = _interopRequireDefault(require("./ImportTable.vue"));
var Import = /*#__PURE__*/function (_Vue) {
  function Import() {
    var _this;
    (0, _classCallCheck2.default)(this, Import);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, Import, [].concat(args));
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      limit: 50,
      search: "",
      categoryId: "",
      status: null
    });
    (0, _defineProperty2.default)(_this, "tabName", "");
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "categories", []);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "selection", []);
    (0, _defineProperty2.default)(_this, "ImportStatus", ImportStatus);
    (0, _defineProperty2.default)(_this, "ImportStatusTrans", ImportStatusTrans);
    (0, _defineProperty2.default)(_this, "loadingButton", false);
    return _this;
  }
  (0, _inherits2.default)(Import, _Vue);
  return (0, _createClass2.default)(Import, [{
    key: "transformTable",
    get: function get() {
      var data = [];
      this.data.forEach(function (e) {
        var stock = e.idNhanh == 25778502 ? e.quantityRemain : e.quantityStock;
        e.quantityTotal = stock + e.quantityImport - e.quantityShipping;
        e.checkLimit = ImportStatus.HighLimit;
        if (e.quantityTotal <= e.productConfig.limit) {
          e.checkLimit = ImportStatus.LowLimit;
        } else if (e.quantityTotal <= e.productConfig.limit * 1.3) {
          e.checkLimit = ImportStatus.NearLimit;
        }
        data.push(e);
      });
      return data;
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchCategory();
    }
  }, {
    key: "handleUpdateProduct",
    value: function () {
      var _handleUpdateProduct = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var i;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loadingButton = true;
              _context.prev = 1;
              i = 0;
            case 3:
              if (!(i < 7)) {
                _context.next = 9;
                break;
              }
              _context.next = 6;
              return _nhanh.nhanhApi.findAllProducts({
                limit: 50,
                page: i + 1
              });
            case 6:
              i++;
              _context.next = 3;
              break;
            case 9:
              this.$notify({
                title: "Cập nhật sản phẩm",
                message: "Successfully",
                type: "success"
              });
            case 10:
              _context.prev = 10;
              this.loadingButton = false;
              return _context.finish(10);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1,, 10, 13]]);
      }));
      function handleUpdateProduct() {
        return _handleUpdateProduct.apply(this, arguments);
      }
      return handleUpdateProduct;
    }()
  }, {
    key: "handleChange",
    value: function handleChange(value) {
      this.query.page = 1;
      this.query.categoryId = value.name;
      this.$router.push("/import/index#".concat(value.name));
      this.fetchData();
    }
  }, {
    key: "handleSelection",
    value: function handleSelection(val) {
      this.selection = val;
    }
  }, {
    key: "handleAdd",
    value: function handleAdd() {
      this.$refs.importModal.handleCreate(this.tabName, this.selection);
    }
  }, {
    key: "handleView",
    value: function handleView(data) {
      this.$refs.detailImport.handleView(data);
    }
  }, {
    key: "fetchCategory",
    value: function () {
      var _fetchCategory = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var excludes, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              excludes = ["MPEF", "QTKH", "TCN"];
              _context2.next = 3;
              return _nhanh.nhanhApi.productCategory();
            case 3:
              res = _context2.sent;
              this.categories = res.data.filter(function (e) {
                return !excludes.includes(e.code);
              });
              if (this.categories.length) {
                this.tabName = this.categories[0].id;
                this.query.categoryId = this.categories[0].id;
                if (this.$route.hash) {
                  this.tabName = this.$route.hash.replace("#", "");
                  this.query.categoryId = this.$route.hash.replace("#", "");
                }
                this.fetchData();
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchCategory() {
        return _fetchCategory.apply(this, arguments);
      }
      return fetchCategory;
    }()
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _product.productApi.findAllImport(this.query);
            case 2:
              res = _context3.sent;
              this.data = res.data.products;
              this.total = res.data.total;
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
Import = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ImportTable: _ImportTable.default,
    ImportModal: _ImportModal.default,
    DetailImportModal: _DetailImportModal.default
  }
})], Import);
var _default = exports.default = Import;
var ImportStatus;
(function (ImportStatus) {
  ImportStatus["LowLimit"] = "LOW_LIMIT";
  ImportStatus["NearLimit"] = "NEAR_LIMIT";
  ImportStatus["HighLimit"] = "HIGH_LIMIT";
})(ImportStatus || (exports.ImportStatus = ImportStatus = {}));
var ImportStatusTrans = exports.ImportStatusTrans = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, ImportStatus.LowLimit, "Dưới hạn mức"), ImportStatus.NearLimit, "Gần hạn mức"), ImportStatus.HighLimit, "Trên hạn mức");